import { render, staticRenderFns } from "./ConnectionSkeleton.vue?vue&type=template&id=67ef7eed&lang=pug&"
import script from "./ConnectionSkeleton.vue?vue&type=script&lang=js&"
export * from "./ConnectionSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionSkeleton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/tmp/7924dce7/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileActionText } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileSubTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VIcon,VList,VListTile,VListTileAction,VListTileActionText,VListTileContent,VListTileSubTitle,VMenu})
